import { createFetchHttpClient } from '../../infrastructure/http/createFetchHttpClient';
import { HttpKanbanGateway } from '../../infrastructure/kanban/HttpKanbanGateway';
import { createLoadKanbanDashboard } from '../../application/useCases/createLoadKanbanDashboard';
import { getFrontendEnvironment } from '../../shared/config/env';
import { createKanbanDashboardController } from './createKanbanDashboardController';

export function useKanbanDashboard() {
  const environment = getFrontendEnvironment();
  const httpClient = createFetchHttpClient();
  const kanbanGateway = new HttpKanbanGateway({
    httpClient,
    apiBaseUrl: environment.apiBaseUrl,
  });
  const loadKanbanDashboard = createLoadKanbanDashboard({ kanbanGateway });

  return createKanbanDashboardController({
    loadKanbanDashboard,
    refreshIntervalMs: environment.refreshIntervalMs,
  });
}
